import { useTranslation } from "react-i18next";
import { Body1 } from "@myphx-engineering/phx-design-system";
import { jsx } from "react/jsx-runtime";

//#region src/hooks/UseActivityConfig.tsx
const useActivityConfig = ({ prescriberOrder, navigateToRenewalStatus, navigateToOrderConfirmation, pharmacyName, enableRxCancel, enableRxRenewal, titleCase, RenewalStatus, PrescriberOrderStatus, isRouted }) => {
	const { t } = useTranslation("phx-lib");
	const { status, renewalDetails, assignmentTimestamp, latestSelectedPriceQuoteTimestamp, latestSelectedOfferTimestamp, cancelDetails } = prescriberOrder;
	const pharmacyTimestamp = assignmentTimestamp || latestSelectedOfferTimestamp || latestSelectedPriceQuoteTimestamp;
	const activities = [];
	if (enableRxRenewal && renewalDetails?.status) switch (renewalDetails.status) {
		case RenewalStatus.Denied:
			activities.push({
				label: t("activityConfig.refillDenied"),
				timestamp: renewalDetails.timestamp,
				timeZone: "UTC",
				action: {
					label: t("activityConfig.viewDetails"),
					onClick: navigateToRenewalStatus
				}
			});
			break;
	}
	if (enableRxCancel && status === PrescriberOrderStatus.Cancelled) activities.push({
		label: t("activityConfig.cancelledByProvider"),
		timestamp: cancelDetails?.timestamp,
		timeZone: "UTC",
		additionalContent: !pharmacyTimestamp ? /* @__PURE__ */ jsx(Body1, { children: t("activityConfig.notSentToPharmacy") }) : null,
		action: pharmacyTimestamp && navigateToOrderConfirmation ? {
			label: t("activityConfig.viewOrder"),
			onClick: navigateToOrderConfirmation
		} : void 0
	});
	if (pharmacyTimestamp && status !== PrescriberOrderStatus.Cancelled) {
		const isInProgress = status === PrescriberOrderStatus.Pending;
		activities.push({
			label: isRouted === false && isInProgress ? t("activityConfig.inProgress") : t("activityConfig.sentToPharmacy"),
			timestamp: pharmacyTimestamp,
			timeZone: assignmentTimestamp ? void 0 : "UTC",
			additionalContent: pharmacyName ? /* @__PURE__ */ jsx(Body1, { children: titleCase ? titleCase(pharmacyName) : pharmacyName }) : null,
			action: navigateToOrderConfirmation ? {
				label: t("activityConfig.viewOrder"),
				onClick: navigateToOrderConfirmation
			} : void 0
		});
	}
	return activities;
};

//#endregion
export { useActivityConfig };